import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Notification from 'app/components/general/Notification';
import classnames from 'classnames';

import { Link } from 'react-router-dom';

import history from 'app/routes/history';
import HeaderThin from 'app/components/layout/HeaderThin';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import MatchesTable from 'app/components/matches/MatchesTable';

import _ from 'lodash';
import {
  ITeamsSelector, IPaymentEventsSelector, IOrganisationsSelector, IGroupsSelector,
} from 'app/types/selector';
import * as paymentEventsActions from 'app/ducks/paymentEvents/actions';
import * as teamsActions from 'app/ducks/teams/actions';
import * as groupsActions from 'app/ducks/groups/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as paymentEventsSelectors from 'app/ducks/paymentEvents/selectors';
import * as teamsSelectors from 'app/ducks/teams/selectors';
import * as organisationsSelectors from 'app/ducks/organisations/selectors';
import * as groupsSelectors from 'app/ducks/groups/selectors';

import PaymentCardMin from 'app/components/matches/PaymentCardMin';

function selector(state): any {
  return {
    appReady: loadingSelectors.appReady(state),
    paymentEvents: paymentEventsSelectors.getPaymentEvents(state),
    teams: teamsSelectors.getTeams(state),
    organisations: organisationsSelectors.getOrganisations(state),
    groups: groupsSelectors.getGroups(state),
    isLoading: state.payments.isLoading,
    errors: { ...state.paymentEvents.backendErrors },
  };
}

const actionCreators = _.merge(paymentEventsActions, teamsActions, groupsActions);

interface IListPaymentsAllTeamsProps {
  appReady: any;
  teams: ITeamsSelector;
  paymentEvents: IPaymentEventsSelector;
  organisations: IOrganisationsSelector;
  groups: IGroupsSelector;
  actions: any;
  isLoading: boolean;
  errors: any;
}

interface IListPaymentsAllTeamsState {
  paymentStatus: any;
}

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class ListPaymentsAllTeams extends React.Component<
IListPaymentsAllTeamsProps,
IListPaymentsAllTeamsState
> {
  static defaultProps: IListPaymentsAllTeamsProps = {
    paymentEvents: {},
    teams: {},
    organisations: {},
    groups: {},
    actions: undefined,
    isLoading: false,
    appReady: false,
    errors: {},
  };

  state: IListPaymentsAllTeamsState = {
    paymentStatus: { id: 'pending', name: 'Unpaid' },
  };

  componentDidMount = () => {
    // if (!this.props.teams.currentTeam.connectedToAssociation) {
    //   history.push('/dashboard');
    // } else {
    this.props.actions.getAllPaymentEventsForAllTeams();
    // }
  };

  handleSelectPaymentStatus = (e): void => {
    this.setState({ paymentStatus: e });
  };

  groupIds = () => {
    const groupIds = [];

    _.each(this.props.teams.teamsById, (t) => {
      _.each(t.groups, (g) => {
        if (!_.isEmpty(g?.id)) {
          groupIds.push({ teamId: t.id, groupId: g?.id });
        }
      });
    });

    return _.uniqBy(groupIds, (u) => u.groupId);
  }

  render(): React.ReactNode {
    return (
      <div>
        <div className="row">
          <div className="col">
            This forfeit will be processed as a COVID forfeit. A special fee will be applied, according to your association's policy.
          </div>
        </div>
        <div className="row with-margin-top">
          <div className="col">
            <MatchesTable
              {...this.props.paymentEvents}
              hideAmount
              hideActions
              headerTitle="Select a Match"
              groupIds={this.groupIds()}
              groupsById={this.props.groups.groupsById}
              appReady={this.props.appReady}
              selectTeam={this.props.actions.selectTeam}
              actions={this.props.actions}
              handleClick={(id, row) => {
                history.push(
                  `/forfeit/${row.paymentEventId}/${row.groupId}/submit/covid`,
                );
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}
